class exports.Service
    constructor: (@http, @rootScope) ->
        return

    ###
     * Executes a post to the given url with the given request, and when it completes,
     * fires the given event on @rootScope, passing the following object structure:
     *
     * {
     *     request: request <- this is the request data that was passed in to _postBroadcast()
     *     response: response <- the actual response from the post
     * }
     *
    ###
    _postBroadcast: (request, url, event) =>
        post = @http.post url, request

        post.then (response) =>
            @rootScope.$broadcast event, { request, response }

        return post


    _postPermissionsCheck: (id, url) =>
        return @http.post url, { id }


    handleJsonResponse: (jsr) ->
        if jsr.data?.status?.type is 'success'
            return jsr.data?.data
        else
            return null
